import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";

const columns = (naviagteTo, showModal) => [
    {
      title: " Nom",
      dataIndex: "firstname",
      key: "name",
    },
    {
      title: " Prénom",
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: "Dépot",
      dataIndex: "wholesaler",
      key: "pharmacy",
      render: (data) => <>{data?.companyName}</>,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Gouvernorat",
      dataIndex: "government",
      key: "gouvernorat",
      render: (data) => <>{data?.name}</>,
    },
    {
      title: "Région",
      dataIndex: "region",
      key: "region",
      render: (data) => <>{data?.name}</>,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Téléphone",
      dataIndex: "phoneNumber",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          
          {/* BOUTON MODIFIER (Bleu foncé arrondi) */}
          <Button
            className="btn-details" 
            onClick={() => naviagteTo(`edit/grossiste/${record.id}`)}
            icon={<EditOutlined />} 
          >
            Modifier
          </Button>

          {/* BOUTON SUPPRIMER (Icône Rouge) */}
          <Button 
            type="text" 
            danger 
            onClick={() => showModal(record.id)}
            icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
          />
        </div>
      ),
    },
  ];

  export default columns;